import React from "react";
import { Route, Routes } from "react-router";
import HomePage from "../pages/HomePage/HomePage";
import HowToPayPage from "../pages/HowToPayPage/HowToPayPage";
import DeliveryAndPaymentPage from "../pages/DeliveryAndPaymentPage/DeliveryAndPaymentPage";
import GoodsReturnPage from "../pages/GoodsReturnPage/GoodsReturnPage";
import SchemasPage from "../pages/SchemasPage/SchemasPage";
import SalesAndNewsPage from "../pages/SalesAndNewsPage/SalesAndNewsPage";
import GiftsPage from "../pages/GiftsPage/GiftsPage";
import AboutUsPage from "../pages/AboutUsPage/AboutUsPage";
import ContactsPage from "../pages/ContactsPage/ContactsPage";
import VacanciesPage from "../pages/VacanciesPage/VacanciesPage";
import WriteToUsPage from "../pages/WriteToUsPage/WriteToUsPage";
import WriteToManagerPage from "../pages/WriteToManagerPage/WriteToManagerPage";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";
import YoungDesignersPage from "../pages/YoungDesignersPage/YoungDesignersPage";
import SampleQuestionnairePage from "../pages/SampleQuestionnairePage/SampleQuestionnairePage";
import PersonalDataPolicyPage from "../pages/PersonalDataPolicyPage/PersonalDataPolicyPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage/PrivacyPolicyPage";
import CatalogPage from "../pages/CatalogPage/CatalogPage";
import ProductPage from "../pages/ProductPage/ProductPage";
import CartPage from "../pages/CartPage/CartPage";
import FavoritesPage from "../pages/FavoritesPage/FavoritesPage";
import PaymentPage from "../pages/PaymentPage/PaymentPage";
import ReceiptPage from "../pages/ReceiptPage/ReceiptPage";
import TestPage from "../pages/TestPage/TestPage";

const navigationRoutes = [
  { path: "/", element: <HomePage /> },
  { path: "/how-to-pay", element: <HowToPayPage /> },
  { path: "/delivery-and-payment", element: <DeliveryAndPaymentPage /> },
  { path: "/goods-return", element: <GoodsReturnPage /> },
  { path: "/schemas", element: <SchemasPage /> },
  { path: "/sales-and-news", element: <SalesAndNewsPage /> },
  { path: "/gifts", element: <GiftsPage /> },
  { path: "/about-us", element: <AboutUsPage /> },
  { path: "/contacts", element: <ContactsPage /> },
  { path: "/vacancies", element: <VacanciesPage /> },
  { path: "/write-to-us", element: <WriteToUsPage /> },
  { path: "/write-to-manager", element: <WriteToManagerPage /> },
  { path: "/young-designers", element: <YoungDesignersPage /> },
  { path: "/sample-questionnare", element: <SampleQuestionnairePage /> },
  { path: "/policy", element: <PersonalDataPolicyPage /> },
  { path: "/privacy", element: <PrivacyPolicyPage /> },
  { path: "/catalog", element: <CatalogPage /> },
  { path: "/product", element: <ProductPage /> },
  { path: "/product/:id", element: <ProductPage /> },
  { path: "/cart", element: <CartPage /> },
  { path: "/favorites", element: <FavoritesPage /> },
  { path: "/payment", element: <PaymentPage /> },
  { path: "/receipt/:receiptId", element: <ReceiptPage /> },
  { path: "/test", element: <TestPage /> },
  { path: "*", element: <NotFoundPage /> },
];

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {navigationRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default AppRoutes;
